import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { dashboardActions } from '../../../../store/slices/dashboardSlice/dashboardSlice';
import { exportDocument } from '../../Blocks/DocumentationBlock/Components/DocumentDownloadBlock/useDocumentDownloadBlock';
import { DashboardEstimate } from '../../types/dashboardInformation';
import { useTranslation } from 'react-i18next';

export const useModalDocumentInfo = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const headerMapping: Record<string, string> = {
        doc_kp: t('useModalDocumentInfo.headerMapping.doc_kp'),
        doc_contract: t('useModalDocumentInfo.headerMapping.doc_contract'),
        doc_your_contract: t('useModalDocumentInfo.headerMapping.doc_your_contract'),
        doc_your_proposal: t('useModalDocumentInfo.headerMapping.doc_your_proposal'),
    };

    //@ts-ignore
    const { modalMode, estimates, information } = useSelector((state) => state.dashboardReducer);

    const setInitialState = () => {
        const initialState: { [key: number]: boolean } = {};
        estimates.estimates.map((estimate: DashboardEstimate) => {
            initialState[estimate.id] = true;
        });
        return initialState;
    };

    const [selectedEstimates, setSelectedEstimates] =
        useState<{ [key: number]: boolean }>(setInitialState);

    const [documentFormInfo, setDocumentFormInfo] = useState({
        documentId: '',
        documentDate: '',
    });

    useEffect(() => {
        setDocumentFormInfo({
            documentId: information.contract_number,
            documentDate: information.contract_date,
        });
    }, [modalMode]);

    const onCancel = useCallback(() => {
        dispatch(dashboardActions.onModalMode('null'));
        setSelectedEstimates(setInitialState);
        setDocumentFormInfo({ documentId: '', documentDate: '' });
    }, [modalMode]);

    const onExport = useCallback(() => {
        dispatch(
            dashboardActions.changeInfoDate({
                date: documentFormInfo.documentDate,
                number: documentFormInfo.documentId,
            })
        );
        exportDocument(modalMode, selectedEstimates, documentFormInfo);
    }, [modalMode, selectedEstimates, documentFormInfo]);

    const handleCheckboxClick = (id: number) => {
        setSelectedEstimates((prevActiveEstimates) => {
            const newActiveState = !prevActiveEstimates[id];
            return {
                ...prevActiveEstimates,
                [id]: newActiveState,
            };
        });
    };
    const handleInputChange = useCallback(
        (documentInfoName: string, documentInfoValue: string) => {
            setDocumentFormInfo({ ...documentFormInfo, [documentInfoName]: documentInfoValue });
        },
        [modalMode, documentFormInfo.documentId, documentFormInfo.documentDate]
    );

    const header = headerMapping[modalMode];
    return {
        modalMode,
        onCancel,
        onExport,
        handleInputChange,
        documentFormInfo,
        handleCheckboxClick,
        selectedEstimates,
        estimates,
        header,
    };
};
